import {ChangeDetectionStrategy, Component, TemplateRef} from '@angular/core';
import {DatePipe} from '@angular/common';
import {EasternTimePipe} from '@irb-common/pipes/EasternTimePipe';
import {AgRendererComponent} from 'ag-grid-angular';

@Component({ standalone: false,
    selector: 'dux-port-col-formatter',
    // styleUrls: [ './portfolios.component.scss' ],
    templateUrl: './portcolformatter.component.html',
    providers: [DatePipe, EasternTimePipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PortColFormatterComponent implements AgRendererComponent {
    params: any;
    displayValue: any;
    linkEnable = false;
    isCurrency = false;
    isPercent = false;
    isNegative = false;
    isNotApplicable = false;
    isBold = false;
    isDoubleDash = false;
    isBlank = false;
    appendToStart = '';
    appendToEnd = '';
    displayETtext = false;
    enablePointer = false;
    dropdown = false;
    editIcon = false;
    checkbox = false;
    statusFormatter = false;
    statusFormatterWithLable = false;
    portfolioStatusFormat = false;
    errorMsg = false;
    statusIcon: string;
    displaySymbol: string = '$';
    decimalPosition: string = '0';
    nullCheck: boolean;
    isCashSecuritySymbol = false;
    columnToolTipInfo: string;
    toolTipTitle: string;
    statusFormatterWithSomeIcon = false;
    calltoactionTemplateFunc: Function;
    calltoactionTemplate: TemplateRef<any>;
    showHideIcon: boolean = false;
    showWarnIcon: boolean = false;

    constructor(private dp: DatePipe, private etp: EasternTimePipe) {
    }

    agInit(params: any) {
        this.params = params;
        this.nullCheck = (this.params.nullCheck && this.params.nullCheck === true && (this.params.value === null || this.params.value === undefined)) ? true : false;
        this.editIcon = this.params.type === 'editIcon' ? true : false;
        this.linkEnable = this.params.link ? this.params.link(this.params) : false;
        this.isCurrency = this.params.type === 'currency' ? true : false;
        this.isPercent = this.params.type === 'percent';
        this.isNegative = this.params.isNegative || false;
        this.isNotApplicable = this.params.isNotApplicable || false;
        this.isBold = this.params.isBold || false;
        this.isDoubleDash = this.params.isDoubleDash || false;
        this.isBlank = this.params.isBlank || false;
        this.appendToStart = this.params.appendToStart || "";
        this.appendToEnd = this.params.appendToEnd || "";
        this.dropdown = this.params.type === 'dropdown' ? true : false;
        this.displayETtext = this.params.displayETtext ? true : false;
        this.enablePointer = this.params.enablePointer ? true : false;
        this.checkbox = this.params.type === 'checkbox' ? true : false;
        this.statusFormatter = this.params.type === 'statusFormatter' ? true : false;
        this.statusFormatterWithLable = this.params.statusFormatterWithLable;
        this.errorMsg = this.params.type === 'errorMsg' ? true : false;
        this.portfolioStatusFormat = this.params.type === 'portfolioStatusFormat' ? true : false;
        this.displayValue = this.params.value;
        this.statusFormatterWithSomeIcon = this.params.type === 'statusFormatterWithSomeIcon' ? true : false;
        this.calltoactionTemplateFunc = this.params.calltoactionTemplateFunc ? this.params.calltoactionTemplateFunc : null;
        this.showHideIcon = this.params.showHideIcon ? this.params.showHideIcon(this.params) : false;
        this.showWarnIcon = this.params.showWarnIcon ? this.params.showWarnIcon(this.params) : false;

        if (this.params.data && this.params.data.securitySymbol && this.params.isCashSecuritySymbol) {
            if (this.params.data.securitySymbol === '$CASH') {
                this.isCashSecuritySymbol = true;
            }
        }

        if (this.isCurrency && this.isNotApplicable) {
            this.displayValue = "n/a";
        } else if (this.isCurrency && this.isDoubleDash) {
            this.displayValue = "--";
        } else if (this.isCurrency && this.isBlank) {
            this.displayValue = "";
        } else if (this.isCurrency && this.isNegative) {
            this.displayValue = this.params.value * -1;
        }
        if (this.isPercent) {
            this.displaySymbol = '%';
            if (this.isNotApplicable) {
                this.displayValue = "n/a";
            } else if (this.isDoubleDash) {
                this.displayValue = "--";
            } else if (this.params.value === null  || this.params.value === '') {
                this.displayValue = "";
                this.isBlank = true;
            } else if (this.isNegative) {
                this.displayValue = this.params.value * -1;
            }
        }
        if (this.params && this.params.columnToolTipInfo) {
            if (this.params.data.securitySymbol === '$CASH') {
                this.columnToolTipInfo = this.params.columnToolTipInfo;
            }
        }

        if (this.params.displaySymbol) {
            this.displaySymbol = this.params.displaySymbol;
        }

        if (this.params.decimalPosition) {
            this.decimalPosition = this.params.decimalPosition;
        }

        if (this.params.relVariancePerc === true) {
            if (this.params.value) {
                this.params.value = this.params.value.relVariancePerc;
            }
        }

        if (this.params.type && this.params.type === 'date' && this.params.value && this.params.format) {
            if (this.displayETtext) {
                if (typeof this.params.value !== "number") {
                    this.params.value = this.params.value.replace(" ET", "");
                    this.params.value = (new Date(this.params.value)).getTime();
                }

                this.params.value = this.dp.transform(this.etp.transform(this.params.value), this.params.format) + ' ET';
            } else if (this.params.convertWithNoDisplayETtext) {
                this.params.value = this.dp.transform(this.etp.transform(this.params.value), this.params.format);
            } else {
                this.params.value = this.dp.transform(this.params.value, this.params.format);
            }
        }

        if (this.statusFormatter) {
            let iconName = '';
            // cash report status start
            if (this.params.value && this.params.value.indexOf( 'In Range')!==-1) {
                iconName = 'checkmark-circle';
            }
            if (this.params.value && this.params.value.indexOf( 'Shortfall')!==-1) {
                iconName = 'arrow-down-circle';
            }
            if (this.params.value && this.params.value.indexOf( 'Excess')!==-1) {
                iconName = 'arrow-up-circle';
            }
            // cash report status end

            // Allocation report status start
            if (this.params.value && this.params.value.indexOf('In Tolerance') !==-1) {
                iconName = 'checkmark-circle';
            }
            if (this.params.value && this.params.value.indexOf('Out of Tolerance') !==-1) {
                iconName = 'exclamation-triangle';
            }
            if (this.params.value && this.params.value.indexOf('Failed') !==-1) {
                iconName = 'critical_default';
            }
            if (this.params.value && this.params.value.indexOf('Unresolved') !==-1) {
                iconName = 'critical_default';
            }
            if (this.params.value && this.params.value.indexOf('Skipped') !==-1) {
                iconName = 'skipped';
            }

            // Allocation report status end

            // allocation report details status start
            if (this.params.value === 'InRange') {
                this.params.value = '';
            }

            if (this.params.value === 'BelowBand') {
                this.params.value = 'Below';
                iconName = 'arrow-down-circle';
            }

            if (this.params.value === 'AboveBand') {
                this.params.value = 'Above';
                iconName = 'arrow-up-circle';
            }

            if (this.params.value === 'AllocationStatusAboveBelowBand') {
                this.params.value = 'Out of Range';
                iconName = 'exclamation-triangle';
            }

            // allocation report details status end


            const labelstyle = this.statusFormatterWithLable ? ' status-icon-with-label' : ' status-icon-without-label';
            this.statusIcon = iconName + labelstyle;
            this.params.value = this.statusFormatterWithLable ? this.params.value : '';
        }

        if (this.statusFormatterWithSomeIcon) {
            //Automated rebalance report status
            const statusFilterValue = this.params.value ? this.params.value.toLowerCase() : '';
            if (statusFilterValue.indexOf('resolved') !==-1) {
                this.statusIcon = 'success-circle-icon';
            }
            if (statusFilterValue.indexOf('rebalance error') !==-1
              || statusFilterValue.indexOf('trade error') !==-1
              || statusFilterValue.indexOf('order error') !==-1) {
                this.statusIcon = 'error-icon';
            }
            if (statusFilterValue.indexOf('ignore') !==-1) {
                this.statusIcon = 'ignored-icon';
            }
        }

        if (this.dropdown) {
            if (this.params.value && this.params.value === '(none)') {
                this.params.value = 'none';
            }
            if (!this.params.value) {
                this.params.value = 'none';
            }
        }

        if (this.portfolioStatusFormat && this.params.data) {
            if (this.params.data.status === 'incomplete' || this.params.data.status === 'Unauthorized') {
                this.params.value = 'Incomplete';
            } else {
                if (this.params.data.acctQty === 0 || this.params.data.securityModelId === null || this.params.data.securityModelId === '') {
                    this.params.value = 'Incomplete';
                } else {
                    this.params.value = '';
                }
            }
        }

        this.toolTipTitle = (this.params.tooltipValueFormatter) ? this.params.tooltipValueFormatter(this.params) : this.params.value;
        this.getCalltoactionTemplate();
    }

    refresh(): boolean {
        return false;
    }

    isPopup(): boolean {
        return true;
    }

    click() {
        if (typeof this.params.onClick != "undefined") {
            if (this.params.sendRowIndex) {
                const rowIndex = this.params.rowIndex || this.params.node.rowIndex;
                this.params.onClick(this.params.data, rowIndex);
            } else {
                this.params.onClick(this.params.data);
            }
        }
    }

    onChange() {
        this.params.data[this.params.colDef.field] = this.params.value;
        if (this.params.context && this.params.context.componentParent && this.params.context.componentParent.onRowChange) {
            const rowIndex = this.params.rowIndex || this.params.node.rowIndex;
            this.params.context.componentParent.onRowChange(rowIndex, this.params.data, this.params.colDef.field);
        }
    }

    retainValue(event:any) {
       if (this.params.isCheckedValue != undefined && !this.params.isCheckedValue) {
           const target = event.target;
           if (!this.params.isCheckboxDisabled) {
               if (!target.classList.contains('checkbox-wrapper')) {
                   this.params.value = !this.params.value;
               }
               this.onChange();
           }
           if (this.params && this.params.retainValue && typeof this.params.retainValue === 'function') {
               this.params.retainValue(this.params);
           }
        }
    }

    getCalltoactionTemplate() {
        if(this.calltoactionTemplateFunc) {
            this.calltoactionTemplate = this.calltoactionTemplateFunc(this.params);
        }
    }
}
